const htmlJava = `
    <pre class="py-2"><code ><span class="code-attribute">import</span> java.io.BufferedReader;
    <span class="code-attribute">import</span> java.io.IOException;
    <span class="code-attribute">import</span> java.io.InputStreamReader;
    <span class="code-attribute">import</span> java.io.OutputStream;
    <span class="code-attribute">import</span> java.net.HttpURLConnection;
    <span class="code-attribute">import</span> java.net.MalformedURLException;
    <span class="code-attribute">import</span> java.net.URL;
    
    <span class="code-attribute">public</span> <span class="hljs-class"><span class="code-attribute">class</span> <span class="code-api-red">NetClient</span> </span>{
       <span class="hljs-function"><span class="code-attribute">public</span> <span class="code-attribute">static</span> <span class="code-attribute">void</span> <span class="code-api-red">main</span><span class="hljs-params">(String[] args)</span> </span>{
           <span class="code-attribute">try</span> {
               URL url = <span class="code-attribute">new</span> URL(<span class="code-api-red">${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/12950968.json/?apikey=YOUR_AUTH_KEY/"</span>);
                HttpURLConnection conn = (HttpURLConnection) url.openConnection();
    
                conn.setRequestMethod(<span class="code-api-red">"GET"</span>);
    
                <span class="code-attribute">if</span> (conn.getResponseCode() != <span class="hljs-number">200</span> &amp;&amp; conn.getResponseCode() != <span class="hljs-number">201</span>) {
                    <span class="code-attribute">throw</span> <span class="code-attribute">new</span> RuntimeException(<span class="code-api-red">"Failed : HTTP error code : "</span>
                        + conn.getResponseCode());
                }
    
                BufferedReader br = <span class="code-attribute">new</span> BufferedReader(<span class="code-attribute">new</span> InputStreamReader(
                    (conn.getInputStream())));
    
                String output;
                System.out.println(<span class="code-api-red">"Output from Server .... "</span>);
                <span class="code-attribute">while</span> ((output = br.readLine()) != <span class="code-attribute">null</span>) {
                    System.out.println(output);
                }
    
                conn.disconnect();
    
            } <span class="code-attribute">catch</span> (MalformedURLException e) {
                e.printStackTrace();
            } <span class="code-attribute">catch</span> (IOException e) {
                e.printStackTrace();
            }
       }
    }
    </code></pre>`


const json  = {
    "nro_registro": "334583",
    "sexo": "Femenino",
    "nombres": "Rosa Elena",
    "apellido_paterno": "Fernández",
    "apellido_materno": "Mena",
    "fecha_nacimiento": "13/11/1976",
    "fecha_registro": "18/05/2012",
    "nacionalidad": "Chilena",
    "rut": 12950968,
    "dv": "6",
    "codigo_busqueda": "Técnico en Nivel Superior en Salud",
    "universidad": "No Informada",
    "observaciones": "",
    "fecha_carga": "11/09/2020",
    "antecedentes": [
        {
            "clase_antecedente": "Título",
            "cod_antecedente": "Técnico Laboratorista Dental",
            "fecha_antecedente": "17/08/2000",
            "fecha_registro": "No Informada",
            "nro_resolucion": "412",
            "procedencia": "CFT Santo Tomás",
            "tipo_antecedente": "T"
        }
    ]
}
const textedJson = JSON.stringify(json, undefined, 4);


var hl7 = {
    "resourceType": "Prestador",
    "id": "prestador",
    "text": {
        "status": "generated",
        "div": ""
    },
    "identifier": [
        {
            "use": "oficial",
            "system": "RNPI",
            "value": ""
        }
    ],
    "assigner": {
        "display": "Técnico Laboratorista Dental"
    },
    "active": true,
    "name": [
        {
            "use": "oficial",
            "text": "Rosa Elena Fernández Mena",
            "family": "Fernández Mena",
            "given": "Rosa Elena"
        }
    ],
    "telecom": [
        {
            "system": "phone",
            "value": "942306852",
            "use": "work"
        }
    ],
    "gender": "Femenino",
    "birthDate": "13/11/1976",
    "qualification": [
        {
            "identifier": [
                {
                    "system": "RNPI",
                    "value": ""
                }
            ],
            "issuer": {
                "display": "No Informada"
            }
        }
    ]
}

var hl7Json = JSON.stringify(hl7, undefined, 4);


    

var htmlPhp = `
<pre class="py-2"><code class="php hljs"><span class="code-api-skyblue">&lt;?php</span>
$service_url = <span class="code-api-red">${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/12950968.json/?apikey=YOUR_AUTH_KEY/</span>;
$curl = curl_init($service_url);
curl_setopt($curl, CURLOPT_RETURNTRANSFER, <span class="code-attribute">true</span>);
$curl_response = curl_exec($curl);
<span class="code-attribute">if</span> ($curl_response === <span class="code-attribute">false</span>) {
    $info = curl_getinfo($curl);
    curl_close($curl);
    <span class="code-attribute">die</span>(<span class="code-api-red">'error occured during curl exec. Additional info: '</span> . var_export($info));
}
curl_close($curl);
$decoded = json_decode($curl_response);
<span class="code-attribute">if</span> (<span class="code-attribute">isset</span>($decoded-&gt;status) &amp;&amp; $decoded-&gt;status != <span class="hljs-number">200</span>) {
    <span class="code-attribute">echo</span> var_export($decoded);
    <span class="code-attribute">die</span>(<span class="code-api-red">'error occured: '</span> . $decoded-&gt;error-&gt;description);
}
<span class="code-attribute">echo</span> $curl_response . PHP_EOL
<span class="code-api-skyblue">?&gt;</span></code></pre>`

var htmlRuby = `
<pre class="py-2"><code><span class="code-attribute">require</span> <span class="code-api-red">'net/http'</span>
<span class="code-attribute">require</span> <span class="code-api-red">'uri'</span>
<span class="code-attribute">require</span> <span class="code-api-red">'json'</span>

uri = URI(<span class="code-api-red">${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/12950968.json/?apikey=YOUR_AUTH_KEY/</span>)
http = Net::HTTP.new(uri)

headers = {}
request = Net::HTTP::Get.new(uri.request_uri, headers)

response = http.request(request)
JSON.parse(response);
</code></pre>`

var htmlNode = `<pre><code class="node hljs coffeescript">const https = <span class="code-attribute">require</span>(<span class="code-api-red">'https'</span>)


const options = {
    hostname: <span class="code-api-red">${process.env.REACT_APP_ENLACE_EXT}</span>,
    port: <span class="hljs-number">443</span>,
    path: <span class="code-api-red">'prestadores/rut/12950968.json/?apikey=YOUR_AUTH_KEY/</span>,
    method: <span class="code-api-red">'GET'</span>,
}

https.request(options, <span class="hljs-function"><span class="hljs-params">(resp)</span> =&gt;</span> {
    let data = <span class="code-api-red">''</span>;

    resp.<span class="hljs-literal">on</span>(<span class="code-api-red">'data'</span>, <span class="hljs-function"><span class="hljs-params">(chunk)</span> =&gt;</span> {
        data += chunk;
    });

    resp.<span class="hljs-literal">on</span>(<span class="code-api-red">'end'</span>, <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
        <span class="code-attribute">console</span>.log(JSON.parse(data));
    });

}).<span class="hljs-literal">on</span>(<span class="code-api-red">'error'</span>, <span class="hljs-function"><span class="hljs-params">(err)</span> =&gt;</span> {
    <span class="code-attribute">console</span>.log(<span class="code-api-red">"Error: "</span>  + err.message);
});</code></pre>`

var htmlGo = `<pre><code class="go hljs"><span class="code-attribute">package</span> main

<span class="code-attribute">import</span> (
    <span class="code-api-red">"encoding/json"</span>
    <span class="code-api-red">"fmt"</span>
    <span class="code-api-red">"net/http"</span>
    <span class="code-api-red">"io/ioutil"</span>
)

<span class="hljs-function"><span class="code-attribute">func</span> <span class="hljs-title">main</span><span class="hljs-params">()</span></span> {
    url := <span class="code-api-red">${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/12950968.json/?apikey=YOUR_AUTH_KEY"</span>
    fmt.Println(<span class="code-api-red">"URL:&gt;"</span>, url)

    req, err := http.NewRequest(<span class="code-api-red">"GET"</span>, url, <span class="hljs-literal">nil</span>)
    <span class="code-attribute">if</span> err != <span class="hljs-literal">nil</span> {
        <span class="code-attribute">panic</span>(err)
    }

    client := http.DefaultClient
    resp, err := client.Do(req)
    <span class="code-attribute">if</span> err != <span class="hljs-literal">nil</span> {
        <span class="code-attribute">panic</span>(err)
    }
    <span class="code-attribute">defer</span> resp.Body.Close()

    fmt.Println(<span class="code-api-red">"%v"</span>, resp.Status)
    body, err := ioutil.ReadAll(resp.Body)
    <span class="code-attribute">if</span> err != <span class="hljs-literal">nil</span> {
        <span class="code-attribute">panic</span>(err)
    }
    fmt.Println(<span class="code-api-red">"%v"</span>, <span class="code-attribute">string</span>(body))
}
</code></pre>`

var htmlSwift = `<pre><code class="swift hljs"><span class="code-attribute">open</span> <span class="hljs-function"><span class="code-attribute">func</span> <span class="hljs-title">dataTask</span><span class="hljs-params">(with request: URLRequest,
    completionHandler: @escaping <span class="hljs-params">(Data?, URLResponse?, Error?)</span></span></span> -&gt; <span class="hljs-type">Swift</span>.<span class="hljs-type">Void</span>
    ) -&gt; <span class="hljs-type">URLSessionDataTask</span>

<span class="code-attribute">let</span> endpoint: <span class="hljs-type">String</span> = <span class="code-api-red">${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/12950968.json/?apikey=YOUR_AUTH_KEY"</span>
<span class="code-attribute">guard</span> <span class="code-attribute">let</span> url = <span class="hljs-type">URL</span>(string: endpoint) <span class="code-attribute">else</span> {
  <span class="code-attribute">print</span>(<span class="code-api-red">"Error: cannot create URL"</span>)
  <span class="code-attribute">return</span>
}
<span class="code-attribute">let</span> urlRequest = <span class="hljs-type">URLRequest</span>(url: url)
<span class="code-attribute">let</span> session = <span class="hljs-type">URLSession</span>.shared

<span class="code-attribute">let</span> task = session.dataTask(with: urlRequest) { data, response, error <span class="code-attribute">in</span>

  <span class="code-attribute">guard</span> error == <span class="hljs-literal">nil</span> <span class="code-attribute">else</span> {
    <span class="code-attribute">print</span>(<span class="code-api-red">"error calling API"</span>)
    <span class="code-attribute">print</span>(error!)
    <span class="code-attribute">return</span>
  }

  <span class="code-attribute">guard</span> <span class="code-attribute">let</span> responseData = data <span class="code-attribute">else</span> {
    <span class="code-attribute">print</span>(<span class="code-api-red">"Error: did not receive data"</span>)
    <span class="code-attribute">return</span>
  }

  <span class="code-attribute">do</span> {
    <span class="code-attribute">guard</span> <span class="code-attribute">let</span> result = <span class="code-attribute">try</span> <span class="hljs-type">JSONSerialization</span>.jsonObject(with: responseData, options: [])
      <span class="code-attribute">as</span>? [<span class="hljs-type">String</span>: <span class="hljs-type">Any</span>] <span class="code-attribute">else</span> {
        <span class="code-attribute">print</span>(<span class="code-api-red">"Could not get JSON from responseData as dictionary"</span>)
        <span class="code-attribute">return</span>
      }
    <span class="code-attribute">print</span>(result)
  } <span class="code-attribute">catch</span>  {
    <span class="code-attribute">print</span>(<span class="code-api-red">"error trying to convert data to JSON"</span>)
    <span class="code-attribute">return</span>
  }
}

task.resume()
</code></pre>
`
var htmlC = `<pre><code class="csharp hljs"><span class="code-attribute">using</span> System;
<span class="code-attribute">using</span> System.Net;
<span class="code-attribute">using</span> System.IO;
<span class="code-attribute">using</span> System.Text;

<span class="code-attribute">class</span> <span class="hljs-title">Program</span>
{
   <span class="hljs-function"><span class="code-attribute">static</span> <span class="code-attribute">void</span> <span class="hljs-title">Main</span>(<span class="hljs-params"><span class="code-attribute">string</span>[] args</span>)</span>
   {
       <span class="code-attribute">try</span>
       {
           <span class="code-attribute">string</span> url = <span class="code-api-red">${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/12950968.json/?apikey=YOUR_AUTH_KEY"</span>;
            HttpWebRequest request = (HttpWebRequest)WebRequest.Create(url);

            request.Method = <span class="code-api-red">"GET"</span>;

            <span class="code-attribute">var</span> response = (HttpWebResponse)request.GetResponse();
           <span class="code-attribute">var</span> responseString = <span class="code-attribute">new</span> StreamReader(response.GetResponseStream()).ReadToEnd();
           Console.WriteLine(responseString);

        } 
        <span class="code-attribute">catch</span>(Exception ex) {
            Console.WriteLine(<span class="code-api-red">"Failed : HTTP error code : "</span> + ex.Message);
        }
   }
}
</code></pre>
`


const lenguajes1 = ["cURL","Python","R","Java","PHP"]
const lenguajes2 = ["Ruby","Node","Go","Swift","C#"]

  //VALIDAR ENTRADA SOLO NUMEROS
  const Numeros = (e) =>{
    let key = e.keyCode || e.which;
    let teclado = String.fromCharCode(key);

    let numeros = "0123456789";
    
    let especiales="8-37-38-46";

    let teclado_especial = false;

    for(var i in especiales){
        if(key===especiales[i]){
            teclado_especial = true;
        }
    }
    
    if(numeros.indexOf(teclado) === -1 && !teclado_especial){
        return false;
    }
}

module.exports = {  htmlJava: htmlJava, textedJson: textedJson, hl7Json: hl7Json, htmlPhp: htmlPhp, htmlRuby: htmlRuby, htmlNode: htmlNode, htmlGo: htmlGo, htmlSwift: htmlSwift, htmlC: htmlC, lenguajes1: lenguajes1, lenguajes2: lenguajes2, Numeros: Numeros}